export const BREAKPOINTCONFIG = { xs: 0, sm: 600, md: 992, lg: 1280, xl: 1920 };
